import * as CONFIG from 'config';
import defaultCss from './default.module.css';
import css from 'styles/Navigations.module.css';
import classnames from 'classnames/bind';
import { useContext } from 'react';
import { CatalogContext } from 'Catalog/Catalog.context';
import CatalogLink from 'Catalog/CatalogLink';
import { PrevButton, NextButton } from 'Catalog/PagingButtons';
import AutoplayButton from 'Catalog/AutoplayButton';

const cx = classnames.bind(css);

export default function Navigations() {
  return (
    <div className={defaultCss.container}>
      <Sidebar />
      <Lnb />
    </div>
  );
}

function Sidebar() {
  const { activePageInfo, lang, pageNum } = useContext(CatalogContext);
  if (!activePageInfo || !lang) {
    return null;
  }

  return (
    <aside
      className={cx('sidebar', activePageInfo.sidebarState === 'show' ? 'show' : 'hide')}
    >
      <CatalogLink
        to={2}
        className={cx('btn', 'btn--index')}
      >
        <div className={cx('ico-menu')}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </CatalogLink>
      <div className={cx('gnb')}>
        <CatalogLink
          to={3}
          className={cx(
            'btn',
            'btn--gnb',
            activePageInfo.depth1 === 'machine' ? 'active' : ''
          )}
        >
          <img
            src={`${CONFIG.IMG_URL}/common/gnb-1.png`}
            alt=''
          />
          <span>MACHINE</span>
        </CatalogLink>
        <CatalogLink
          to={5}
          className={cx(
            'btn',
            'btn--gnb',
            activePageInfo.depth1 === 'tech' ? 'active' : ''
          )}
        >
          <img
            src={`${CONFIG.IMG_URL}/common/gnb-2.png`}
            alt=''
          />
          <span>TECHNOLOGY</span>
        </CatalogLink>
        <CatalogLink
          to={12}
          className={cx(
            'btn',
            'btn--gnb',
            activePageInfo.depth1 === 'after-service' ? 'active' : ''
          )}
        >
          <img
            src={`${CONFIG.IMG_URL}/common/gnb-3.png`}
            alt=''
          />
          <span>SERVICE</span>
        </CatalogLink>
      </div>
      <nav className={cx('control')}>
        <PrevButton className={cx('control-btn', 'prev')}>
          <i className='arrow left'></i>
        </PrevButton>
        <NextButton className={cx('control-btn', 'next')}>
          <i className='arrow right'></i>
        </NextButton>
      </nav>
    </aside>
  );
}

function Lnb() {
  const { autoplayRunning, activePageInfo } = useContext(CatalogContext);

  const lnbMap = {
    machine: [
      {
        label: 'Introduction',
        page: 3,
        code: 'introduction',
      },
      {
        label: 'Information',
        page: 4,
        code: 'information',
      },
    ],
    tech: [
      {
        label: 'One touch & <br />Multi Pins technology',
        page: 5,
        code: 'intro',
      },
      {
        label: 'Technical <br />Specifications',
        page: 6,
        code: 'spec',
      },
      {
        label: 'Triple structure <br />technology',
        page: 8,
        code: 'triple',
      },
      {
        label: 'Product',
        page: 9,
        code: 'product',
      },
    ],
  };

  return (
    <div className={cx('lnb-bar')}>
      {lnbMap[activePageInfo?.depth1] && (
        <nav className={cx('lnb')}>
          {lnbMap[activePageInfo.depth1].map((item, i) => (
            <CatalogLink
              to={item.page}
              className={cx(
                'lnb-btn',
                item.code === activePageInfo.depth2 ? 'active' : ''
              )}
            >
              <span dangerouslySetInnerHTML={{ __html: item.label }}></span>
            </CatalogLink>
          ))}
        </nav>
      )}
      <nav className={cx('btns')}>
        <CatalogLink
          to={1}
          className={cx('btn', 'btn--home')}
        >
          <img
            src={`${CONFIG.IMG_URL}/common/btn-home.png`}
            alt=''
          />
        </CatalogLink>
        <AutoplayButton className={cx('btn', 'btn--autoplay')}>
          {autoplayRunning ? (
            <img
              src={`${CONFIG.IMG_URL}/common/btn-pause.png`}
              alt=''
              className={cx('play')}
            />
          ) : (
            <img
              src={`${CONFIG.IMG_URL}/common/btn-play.png`}
              alt=''
              className={cx('pause')}
            />
          )}
        </AutoplayButton>
      </nav>
    </div>
  );
}
